import { useTranslation } from 'next-i18next'

import Section from 'components/Section/Section'

import styles from './Coverage.module.scss'

const coverage = [
  {
    year: 2018,
    countries: [['India']],
  },
  {
    year: 2019,
    countries: [['India'], ['Malaysia'], ['Indonesia']],
  },
  {
    year: 2020,
    countries: [['India'], ['Malaysia'], ['Indonesia'], ['Bangladesh'], ['Thailand'], ['Vietnam']],
  },
  {
    year: 2021,
    countries: [
      ['India', 'Malaysia', 'Indonesia'],
      ['Bangladesh', 'Thailand'],
      ['Vietnam', 'Nigeria', 'Brazil'],
      ['Chile', 'Egypt', 'Ghana', 'Kenya'],
      ['Mexico', 'Philippines'],
      ['Pakistan', 'Rwanda', 'Tanzania'],
    ],
  },
  {
    year: 2022,
    countries: [
      ['India', 'Malaysia', 'Indonesia'],
      ['Bangladesh', 'Thailand'],
      ['Vietnam', 'Nigeria', 'Brazil'],
      ['Chile', 'Egypt', 'Ghana', 'Kenya'],
      ['Mexico', 'Philippines'],
      ['Pakistan', 'Rwanda', 'Tanzania'],
      ['Uganda', 'SouthAfrica'],
    ],
  },
]

const YearCoverage = ({ year, countries }) => {
  const { t } = useTranslation(['stats'])

  // t(`stats:ourProgressIndia`)
  // t(`stats:ourProgressMalaysia`)
  // t(`stats:ourProgressIndonesia`)
  // t(`stats:ourProgressBangladesh`)
  // t(`stats:ourProgressThailand`)
  // t(`stats:ourProgressVietnam`)
  // t(`stats:ourProgressNigeria`)
  // t(`stats:ourProgressBrazil`)
  // t(`stats:ourProgressChile`)
  // t(`stats:ourProgressEgypt`)
  // t(`stats:ourProgressGhana`)
  // t(`stats:ourProgressKenya`)
  // t(`stats:ourProgressMexico`)
  // t(`stats:ourProgressPhilippines`)
  // t(`stats:ourProgressPakistan`)
  // t(`stats:ourProgressRwanda`)
  // t(`stats:ourProgressTanzania`)
  // t(`stats:ourProgressUganda`)
  // t(`stats:ourProgressSouthAfrica`)
  return (
    <div className={styles.yearCoverage}>
      <div className={styles.list}>
        {countries.map((cntr) => {
          // if (cntr.lenght > 0) {
          //   return <div className={styles.country}>{t(`stats:ourProgress${cntr}`)}</div>
          // }
          return (
            <div className={styles.country}>
              {cntr
                .map((country) => {
                  return t(`stats:ourProgress${country}`)
                })
                .join(', ')}
            </div>
          )
        })}
      </div>
      <div className={styles.year}>
        <span>{year}</span>
        <span>{t('stats:supportYear')}</span>
      </div>
    </div>
  )
}

const Coverage = () => {
  const { t } = useTranslation(['stats'])
  return (
    <Section backgroundClass={styles.background}>
      <div className={styles.coverage}>
        <div className={styles.grid}>
          <div className={styles.title}>{t('stats:coverageTitle')}</div>
          <div className={styles.coverageList}>
            {coverage.map((cov, idx) => {
              return <YearCoverage key={idx} {...cov} />
            })}
          </div>
        </div>
      </div>
    </Section>
  )
}

export default Coverage
